import { FC } from 'react';
import { FormProvider } from 'react-hook-form';

import { FormLayout } from '../../components/FormLayout';
import { TitleForm } from '../../components/TitleForm';
import { Content } from '../../components/Content';
import { TElement } from '../../types/calculator';
import { useCalculatorForm } from '../../hooks';

interface IFormInnerProps {
  handleSetFormRef: (node: HTMLFormElement | null) => void;
  formRef: HTMLFormElement | null;
  formScheme: TElement[];
}

export const FormInner: FC<IFormInnerProps> = ({ formScheme, formRef, handleSetFormRef }: IFormInnerProps) => {
  const { reactHookForm } = useCalculatorForm(formScheme, formRef);

  return (
    <FormProvider {...reactHookForm}>
      <FormLayout>
        <form ref={handleSetFormRef}>
          <TitleForm>Ипотечный калькулятор</TitleForm>
          <Content elements={formScheme} data-testid="form-content" />
        </form>
      </FormLayout>
    </FormProvider>
  );
};

FormInner.displayName = 'FormInner';
